export default __webpack_public_path__ + "static/media/bg-hideandseek.9b619678.jpg";